/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
// import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Link } from "react-router-dom";

function BalanceCard({ idx, color, currencyCode, symbol, amount, enabled }) {
  // const x = currencyCode !== "N/A" ? currencyCode : undefined;
  // const formatter = new Intl.NumberFormat(x, {
  //   style: "currency",
  //   currency: x !== undefined ? currencyCode : "NGN",

  //   // These options are needed to round to whole numbers if that's what you want.
  //   // minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //   maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
  // });

  function format(amt) {
    return `${symbol}${amt.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  return (
    <Card>
      <MDBox display="flex" justifyContent="space-between" pt={1} px={2}>
        <MDBox
          key={idx}
          variant="gradient"
          bgColor={color}
          color={color === "light" ? "dark" : "white"}
          coloredShadow={color}
          borderRadius="xl"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="4rem"
          height="4rem"
          mt={-3}
        >
          {currencyCode}
        </MDBox>
        <MDBox textAlign="right" lineHeight={1.25} sx={{ mb: 3 }}>
          <MDTypography variant="button" fontWeight="light" color="text">
            Balance
          </MDTypography>
          <MDTypography variant="h5">{format(amount / 100)}</MDTypography>
        </MDBox>
      </MDBox>
      <Divider />
      <MDBox pb={2} px={2} textAlign="right">
        {enabled ? (
          <Link to={`/balances/${currencyCode}`} state={{ currency: currencyCode }}>
            <MDTypography component="span" variant="button" fontWeight="bold">
              Go to balance &nbsp; &gt;
            </MDTypography>
          </Link>
        ) : (
          <MDTypography component="span" variant="button" fontWeight="bold" color="info">
            (Coming soon)
          </MDTypography>
        )}
      </MDBox>
    </Card>
  );
}

function randColor() {
  const colors = ["secondary", "primary", "warning"];
  const x = colors[Math.floor(Math.random() * colors.length)];
  console.log(x);
  return x;
}

// Setting default values for the props of ComplexStatisticsCard
BalanceCard.defaultProps = {
  color: randColor(),
  currencyCode: "N/A",
  symbol: "",
  amount: "0.00",
  idx: "1",
  enabled: true,
};

// Typechecking props for the ComplexStatisticsCard
BalanceCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  idx: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currencyCode: PropTypes.string,
  symbol: PropTypes.string,
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  enabled: PropTypes.oneOfType([PropTypes.bool]),
};

export default BalanceCard;
